// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3YoVz","type":"styles_type__KeALB","choices":"styles_choices__3p1ii"};